import { computeDisplayedDate } from './article-utils';
import { ArticleFragmentFragment } from '~/generated-gql/generated-types';

export const getFormattedLendingDate = (
  graphqlArticle: ArticleFragmentFragment
): string => {
  const displayDate = computeDisplayedDate({
    displayDate: graphqlArticle.dateTimeDisplayDate,
    showLastModifiedDate: graphqlArticle.showLastModifiedDate,
    hideDate: graphqlArticle.hideDate,
    marketplaceEntities: null,
  });

  return (
    displayDate &&
    new Date(displayDate).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  );
};
